module.exports = __webpack_public_path__ + "static/turtle-creek-house16-e75079a6f6f0bd2e3c5c4040d8f08cd5.jpg";